import apiClient from './apiClient';

export async function fetchThreatFeeds() {
  const { data } = await apiClient.get('/threat-intel/feeds');
  return data.map((f) => ({
    ...f,
    status: f.enabled ? 'active' : 'degraded',
    iocCount: f.ioc_count,
    category: f.feed_type
  }));
}

export async function createThreatFeed(payload) {
  const { data } = await apiClient.post('/threat-intel/feeds', payload);
  return data;
}

export async function updateThreatFeed(id, payload) {
  const { data } = await apiClient.put(`/threat-intel/feeds/${id}`, payload);
  return data;
}

export async function syncThreatFeed(id) {
  const { data } = await apiClient.post(`/threat-intel/feeds/${id}/sync`);
  return data;
}

export async function fetchIocMatches() {
  const { data } = await apiClient.get('/threat-intel/iocs');
  return data.map((i) => ({ ...i, severity: String(i.severity || '').toLowerCase() }));
}

export async function createIoc(payload) {
  const { data } = await apiClient.post('/threat-intel/iocs', payload);
  return data;
}

export async function deactivateIoc(id) {
  await apiClient.delete(`/threat-intel/iocs/${id}`);
  return id;
}

export async function fetchDarkWebMentions() {
  const { data } = await apiClient.get('/threat-intel/darkweb/mentions');
  return data.map((m) => ({ ...m, severity: String(m.severity || '').toLowerCase(), status: String(m.status || '').toLowerCase() }));
}

export async function updateDarkWebMentionStatus(id, status) {
  const { data } = await apiClient.patch(`/threat-intel/darkweb/mentions/${id}/status`, { status: status.toUpperCase() });
  return data;
}

export async function fetchWatchlistKeywords() {
  const { data } = await apiClient.get('/threat-intel/darkweb/watchlist');
  return data;
}

export async function createWatchlistKeyword(payload) {
  const { data } = await apiClient.post('/threat-intel/darkweb/watchlist', payload);
  return data;
}

export async function deleteWatchlistKeyword(id) {
  await apiClient.delete(`/threat-intel/darkweb/watchlist/${id}`);
  return id;
}

export async function triggerDarkWebScan() {
  const { data } = await apiClient.post('/threat-intel/darkweb/scan');
  return data;
}
